import { useSizeTracker } from "./hooks/use-size-tracker";

const useElementSize = useSizeTracker;

export { useElementSize };
